import React, { useState } from 'react';
import { useEffect } from 'react';
import initLiff from '../libs/liff/initLiff';

const BookingWithGoogleForm = () => {
    const [profile, setProfile] = useState(null)
    const [isCopy, setIsCopy] = useState(false)

    const getProfileData = async () => {
        const liff = await initLiff()
        if (liff.isLoggedIn()) {
            const requestProfile = await liff.getProfile()
            console.log(requestProfile)
            setProfile(requestProfile)
        }
    }

    useEffect(() => {
        getProfileData()
    }, [])

    return (
        <div>
            <br />
            <h3 align="center">NCT 127 2ND TOUR 'NEO CITY BANGKOK - THE LINK</h3>
            <br />
            <div className='container'>
                <div className="input-group mb-3">
                    <input
                        type="text"
                        className="form-control"
                        aria-label="Recipient's username"
                        aria-describedby="button-addon2"
                        disabled={true}
                        value={!profile ? "Loading..." : profile.userId}
                        id="UID"
                    />
                    <button
                        className="btn btn-outline-primary"
                        type="button" id="button-addon2"
                        onClick={() => {
                            const el = document.getElementById("UID")
                            el.select()
                            el.setSelectionRange(0, 99999)
                            navigator.clipboard.writeText(el.value);
                            setIsCopy(true)
                        }}
                    ><i className="fa-solid fa-clipboard"></i>&nbsp;&nbsp;Copy</button>
                </div>
                {
                    isCopy && <div>
                        <center>
                            <div className='btn btn-outline btn-success rounded-pill'><i className="fa-solid fa-clipboard"></i>&nbsp;&nbsp;&nbsp;Copy Success</div>
                        </center>
                    </div>
                }
                <br />
                {/* <center>
                    <button
                        type="button"
                        className="btn btn-primary"
                        onClick={() => {
                            window.open("https://google.com")
                        }}
                    >จองรถ</button>
                </center> */}
            </div>
        </div>
    );
}

export default BookingWithGoogleForm;
